import store from '@/store'
import * as apiInquiry from '@/api/inquiry'

// お見積もり内容の確認画面
const estimateFinal = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    application_no: '',
    created: '',
    total_fee: 0,
    expiration: '',
    package_lists: [],
    payment_classification: 0,
    payment_name: '',
    offer_code_data: {},
    webuser_id: ''
  },
  getters: {
  },
  mutations: {
    setData: (state, { applicationNo, created, totalFee, expiration, packageLists, paymentName }) => {
      state.application_no = applicationNo
      state.created = created
      state.total_fee = totalFee
      state.expiration = expiration
      state.package_lists = packageLists
      state.payment_name = paymentName   
    },
    setPaymentClassification(state, { paymentClassification }) {
      state.payment_classification = paymentClassification
    },
    setOfferCodeData(state, { offerCodeData }) {
      state.offer_code_data = offerCodeData
    },
    setWebuserId(state, { webuserId }) {
      state.webuser_id = webuserId
    }
  },
  actions: {
    setData({ commit }, { applicationNo, created, totalFee, expiration, packageLists, paymentName }) {
      commit('setData', { applicationNo, created, totalFee, expiration, packageLists, paymentName })
    },
    /**
     * 初期表示の前の認証処理
     * ユーザーが受信メールのURLをクリックしてアクセスしたとき、
     * URLのクエリ文字列として付与されているトークンで認証処理を行う。
     * なお、このメソッドは、Vue Routerの対象ルーティング設定のbeforeEnter()メソッドから実行される。
     */
    async checkToken({ commit }, token) {
      let isAuthorized = false

      if (token !== '') {
        // お見積もり内容確認APIをコール
        // (APIにtokenを渡して認証処理も同時に行う)
        const params = {}
        params.type = 1 // 1:入力画面
        params.token = token

        await apiInquiry.confirmEstimate(params)
          .then(async(response) => {
            if (response) {

              const { data } = response

              if (data.status === 0) {
                // トークン認証OKかつデータ取得成功
                isAuthorized = true

                const data2 = {}
                data2.applicationNo = data.application_no
                data2.created = data.created
                data2.totalFee = data.total_fee
                data2.expiration = data.expiration
                data2.packageLists = data.package_lists
                data2.paymentName = data.payment ?? ''
                await commit('setData', data2)

                // ストアデータのauth/tokenにトークンを設定し保持する
                await store.dispatch('auth/setToken', { token: token, refreshToken: '' })
              }
            }
          })
      }

      return isAuthorized
    },
    /**
     * お支払い方法を設定
     */
    setPaymentClassification({ commit }, paymentClassification) {
      commit('setPaymentClassification', { paymentClassification })
    },
    /**
     * 申込認証コード取得APIのレスポンスを設定
     */
    setOfferCodeData({ commit }, offerCodeData) {
      commit('setOfferCodeData', { offerCodeData })
    },
    /**
     * WEBセッション情報取得APIのwebuser_idを設定
     */
    setWebuserId({ commit }, webuserId) {
      commit('setWebuserId', { webuserId })
    }
  }
}

export default estimateFinal
